import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import { IRealizarLoginDTO } from "./AcessoService";
import { api } from "./Api";
import { ApiResult } from "./ApiResult";
import { RequestBuscarTodasComprasPorUsuarioCompleto } from "@/dtos/Request/RequestBuscarTodasComprasPorUsuarioCompleto";
import { CompraUsuarioDto } from "@/dtos/CompraUsuarioDto";
import { DadosCheckoutCompraRapidaDto } from "@/dtos/Request/RequestDadosCheckoutCompraRapida";
import { CheckoutCompraRapidaSorteioGiroDto } from "@/dtos/Request/CheckoutCompraRapidaSorteioGiroDto";
import { CautelaCompraDto } from "@/dtos/BuscarComprasUltimoSorteioDto";

export interface BuscarClientePorCPFDTO {
    idUsuario: number,
    CPF: string,
    Email: string,
    Nome: string,
    Telefone: string
}

export interface ConsultarPixPagoDto {
    Compra: ConsultarPixPagoCompraDto,
    Data: string,
    DataVencimento: string,
    IdFatura: number,
    QrCode: string,
    QrCodeText: string,
    Situacao: number,
    SituacaoFormatada: string,
    TipoFatura: string,
    URL: string,
    Valor: number
}

export interface ConsultarPixPagoCompraDto {
    IdCompra: number,
    IdUsuario: number,
    Situacao: number,
    Valor: number,
}

export interface BuscarCompraDto {
    Boleto?: QrCodeGeradoDto
    IdCompra: number,
    Valor: number,
    CodigoPagamento: number,
    NumeroPedido: string,
    Data: string,
    DataSorteio: string,
    DataHoraSorteio: string,
    DetalheSituacao: string,
    QuantidadeCautelas: number,
    UrlCertificados: string[],
    Cautelas?: CautelaCompraDto[],
    Situacao: number,
    Usuario: IRealizarLoginDTO
}

export interface CadastrarUsuarioCompraRapidaDto {
    CPF: string,
    Nome: string,
    Telefone: string,
    Email: string,
    Endereco: {
        CEP: string
    }
}

class CompraRapidaService {
    async buscarClientePorCPF(cpf: string, recaptchaToken: string, token?: string) {
        let config = token ? { headers: { Authorization: token } } : undefined;

        const { data: result } = await api.get<ApiResult<BuscarClientePorCPFDTO>>(
            `Compra/BuscarClienteCompraRapida/${cpf}/${encodeURIComponent(recaptchaToken)}`,            
            config
        );
        return result
    }

    async realizarLoginSimples(CPF: string, Telefone: string) {
        const { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>("Bot/Login/", { CPF, Telefone });
        return result;
    }

    async realizarCadastro(dados: CadastrarUsuarioCompraRapidaDto): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Bot/Cadastrar', dados);

        return result;
    }

    async finalizarCompraPix(QtdTitulo: number, token: string, IdVendedor?: number) {
        const { data: result } = await api.post<ApiResult<QrCodeGeradoDto>>("Compra/EfetuarCompraRapidaPIX/", { QtdTitulo, IdVendedor }, {
            headers: {
                Authorization: token
            }
        });
        return result;
    }

    async consultarPixPago(token: string) {
        const { data: result } = await api.post<ApiResult<ConsultarPixPagoDto>>("Compra/VerificarFaturaCompraRapida/", { Token: token });
        return result;
    }

    async buscarCompra(idCompra: number, token: string) {
        let { data: result } = await api.get<ApiResult<CompraUsuarioDto>>("Compra/BuscarCompra/" + idCompra, {
            headers: {
                Authorization: token
            }
        });
        return result;
    }

    async buscarCompraRapida(token: string) {
        let { data: result } = await api.post<ApiResult<CompraUsuarioDto>>("Compra/BuscarCompraRapida/", { Token: token });
        return result;
    }

    async buscarTitulosCompraRapida(cpf: string) {
        let { data: result } = await api.get<ApiResult<RequestBuscarTodasComprasPorUsuarioCompleto>>("Compra/BuscarTitulosCompraRapida/" + cpf);
        return result;
    }

    async CheckoutCompraRapida(dadosCheckout: DadosCheckoutCompraRapidaDto) {
        let { data: result } = await api.post<ApiResult<QrCodeGeradoDto>>('compra/CheckoutCompraRapida', dadosCheckout);

        return result;
    }

    async checkoutCompraRapidaSorteioGiro(dados: CheckoutCompraRapidaSorteioGiroDto) {
        const { data: result } = await api.post<ApiResult<Record<string, unknown>>>(
            "Compra/CheckoutCompraRapidaSorteioGiro",
            dados
        );

        if (result.Data) {
            return {
                ...result,
                Data: normalizarQrCodeGiroResponse(result.Data),
            } as ApiResult<QrCodeGeradoDto>;
        }

        return result as unknown as ApiResult<QrCodeGeradoDto>;
    }
}

function normalizarQrCodeGiroResponse(raw: Record<string, unknown>): QrCodeGeradoDto {
    const situacao = raw.Situacao;
    return {
        IdBoleto: raw.IdBoleto as string | undefined,
        CodigoBarra: (raw.CodigoBarra ?? raw.CodigoBarras) as string | undefined,
        Data: raw.Data as string,
        DataVencimento: raw.DataVencimento as string,
        IdFatura: String(raw.IdFatura ?? ""),
        PDF: raw.PDF as string | undefined,
        QrCode: raw.QrCode as string,
        QrCodeText: raw.QrCodeText as string,
        Situacao: typeof situacao === "string" ? parseInt(situacao, 10) || 0 : (situacao as number),
        SituacaoFormatada: raw.SituacaoFormatada as string,
        TipoFatura: raw.TipoFatura as string,
        Url: (raw.Url ?? raw.URL) as string,
        Valor: raw.Valor as number,
        Compra: raw.Compra as QrCodeGeradoDto["Compra"],
        TokenCompraRapida: raw.TokenCompraRapida as string,
    };
}

export default new CompraRapidaService();